module.exports = __webpack_public_path__ + "img/Kd.4d2d2266.png";